import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36e16b50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fw-bold mb-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xxl-5" }
const _hoisted_4 = { class: "fw-bold ps-2 fs-7 mb-3" }
const _hoisted_5 = { class: "rounded-4 overflow-hidden border-container me-4" }
const _hoisted_6 = { class: "scroll-container overflow-auto" }
const _hoisted_7 = { class: "break-word" }
const _hoisted_8 = { class: "fs-7 ps-3" }
const _hoisted_9 = { class: "fs-7 ps-2 text-break" }
const _hoisted_10 = {
  key: 0,
  class: "fs-7 ps-2 text-break"
}
const _hoisted_11 = { class: "col-xxl-7" }
const _hoisted_12 = { class: "fw-bold ps-2 fs-7 mb-3 mt-5 mt-xxl-0" }
const _hoisted_13 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_14 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-max-content col-lg-1 col-form-label" }, null, -1))
const _hoisted_16 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_17 = { class: "col-lg-12" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_20 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-max-content col-lg-1 col-form-label" }, null, -1))
const _hoisted_22 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_23 = { class: "col-lg-12" }
const _hoisted_24 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "row mx-0 px-0 col-lg-1" }
const _hoisted_27 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_28 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_29 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_30 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_31 = { class: "col-lg-12" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_34 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_35 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_36 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_37 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_38 = { class: "col-lg-12" }
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_41 = { class: "mt-2" }
const _hoisted_42 = { class: "d-flex" }
const _hoisted_43 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_44 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_45 = { class: "row mx-0 px-0 col-lg-7 mt-2" }
const _hoisted_46 = { class: "form-check ms-3" }
const _hoisted_47 = ["for"]
const _hoisted_48 = ["id"]
const _hoisted_49 = { class: "form-check ms-3" }
const _hoisted_50 = ["for"]
const _hoisted_51 = ["id"]
const _hoisted_52 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_53 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_54 = { class: "row mx-0 px-0 col-lg-8 mt-2" }
const _hoisted_55 = { class: "form-check ms-3" }
const _hoisted_56 = ["for"]
const _hoisted_57 = ["id"]
const _hoisted_58 = { class: "form-check ms-3" }
const _hoisted_59 = ["for"]
const _hoisted_60 = ["id"]
const _hoisted_61 = { class: "row mx-0 px-0 col-lg-5" }
const _hoisted_62 = { class: "col-lg-12" }
const _hoisted_63 = { class: "input-group mb-2" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_65 = { class: "col-lg-6 ms-3 px-0" }
const _hoisted_66 = { class: "d-flex" }
const _hoisted_67 = {
  key: 0,
  class: "form-select fs-7",
  "aria-label": "Default select example",
  disabled: ""
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, null, -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "px-3 d-flex align-items-center" }
const _hoisted_72 = {
  key: 2,
  class: "form-select fs-7",
  "aria-label": "Default select example minutes",
  disabled: ""
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, null, -1))
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = ["value"]
const _hoisted_76 = { class: "ps-3 d-flex align-items-center" }
const _hoisted_77 = { class: "invalid-error fs-8 ms-2" }
const _hoisted_78 = { class: "mt-2 mx-2" }
const _hoisted_79 = { class: "mx-2" }
const _hoisted_80 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_81 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_82 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_83 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_84 = { class: "modal-dialog modal-xl" }
const _hoisted_85 = { class: "modal-content" }
const _hoisted_86 = { class: "modal-header" }
const _hoisted_87 = { class: "modal-title w-100 fw-bold text-center" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_89 = { class: "row p-3" }
const _hoisted_90 = { class: "col-xxl-5" }
const _hoisted_91 = { class: "fw-bold ps-2 fs-7 mb-3" }
const _hoisted_92 = { class: "rounded-4 overflow-hidden border-container me-4" }
const _hoisted_93 = { class: "scroll-container overflow-auto" }
const _hoisted_94 = { class: "break-word" }
const _hoisted_95 = { class: "fs-7 ps-3" }
const _hoisted_96 = { class: "fs-7 ps-2 text-break" }
const _hoisted_97 = {
  key: 0,
  class: "fs-7 ps-2 text-break"
}
const _hoisted_98 = { class: "col-xxl-7" }
const _hoisted_99 = { class: "fw-bold ps-2 fs-7 mb-3 mt-5 mt-xxl-0" }
const _hoisted_100 = { class: "border-bottom row mx-0 px-0 gx-3 my-4 pb-4" }
const _hoisted_101 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_102 = { class: "row mx-0 px-0 col-lg-9 fs-7 pt-2 text-break" }
const _hoisted_103 = { class: "border-bottom row mx-0 px-0 gx-3 my-4 pb-4" }
const _hoisted_104 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_105 = { class: "row mx-0 px-0 col-lg-9 fs-7 pt-2 text-break" }
const _hoisted_106 = { class: "border-bottom row mx-0 px-0 gx-3 my-4 pb-4" }
const _hoisted_107 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_108 = { class: "row mx-0 px-0 col-lg-9 fs-7 pt-2 text-break" }
const _hoisted_109 = { class: "border-bottom row mx-0 px-0 gx-3 pb-4 mb-4" }
const _hoisted_110 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_111 = { class: "row mx-0 px-0 col-lg-9 fs-7 flex justify-content align-items-center text-break break-spaces" }
const _hoisted_112 = ["innerHTML"]
const _hoisted_113 = { class: "border-bottom row mx-0 px-0 gx-3 pb-4 mb-4" }
const _hoisted_114 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_115 = { class: "row mx-0 px-0 col-lg-9 fs-7 flex justify-content align-items-center" }
const _hoisted_116 = { class: "row mx-0 px-0 gx-3 pb-4 border-bottom" }
const _hoisted_117 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_118 = { class: "mx-0 px-0 col-lg-9 fs-7 d-flex justify-content align-items-center" }
const _hoisted_119 = { class: "py-4 d-flex justify-content-center fs-7 fw-bold modal-footer" }
const _hoisted_120 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_121 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_122 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_123 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_124 = {
  class: "modal fade",
  id: "modalFinish",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_125 = { class: "modal-dialog" }
const _hoisted_126 = { class: "modal-content" }
const _hoisted_127 = { class: "modal-header" }
const _hoisted_128 = { class: "modal-title w-100 fw-bold text-center" }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { class: "bg-light py-3 ps-3 pe-2 m-4" }
const _hoisted_131 = { class: "me-2" }
const _hoisted_132 = /*#__PURE__*/_createTextVNode()
const _hoisted_133 = { class: "text-center m-4" }
const _hoisted_134 = { class: "modal-footer d-flex justify-content-center" }

import { ref, watch, computed, onMounted, nextTick } from 'vue'
import { numberWithCommas } from '@/constants/common'
import Button from '@/components/button/index.vue'
import Status from '@/components/status/index.vue'
import messageTemplateServices from '@/services/message-template.services'
import { useRoute, useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'
import { GROUPS_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import useVuelidate from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import flatPickr from 'vue-flatpickr-component'
import { HOURS, MINUTES } from '@/constants/regex'
import { configMinDate } from '@/constants/datepicker'
import dayjs from 'dayjs'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { debounce, pick } from 'lodash'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { ConvertFromUTCTime } from '@/constants/datepicker'
import { Modal } from 'bootstrap'
import { REGEX_EMOJI } from '@/constants/regex'
import commonService from '@/services/common.service'
import { customMaxLength, scrollToErrors, purifyContent } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')

dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

const route = useRoute()
const router = useRouter()
const dataMessageTemplate = ref([])
const store = useStore()
const dataReturn = ref([])
const validateTime = ref<boolean>(false)
const listRecordSelected = computed(() => store.getters[GROUPS_STORE.GETTERS.GET_USER_LIST_RECORD_SELECTED])
const detailGroup = computed(() => store.getters[GROUPS_STORE.GETTERS.DETAIL_GROUPS])
const modal = ref()
const modalFinish = ref()
const loadingSend = ref(false)

onMounted(async () => {
  if (listRecordSelected.value?.length === 0 || (!detailGroup.value?.published && detailGroup.value?.invitation_group)) {
    router.push(`/community/communities/${route.params?.id}/admin/groups?created_at=asc`)
  }
  try {
    const res = await messageTemplateServices.getMessageTemplates(route.params.id, { invitation_group: true })
    if (res.data?.success) {
      dataMessageTemplate.value = res?.data
    }
  } catch (error) {
    console.log(error)
  }
  modal.value = new Modal(document.getElementById('modalConfirm'))
  modalFinish.value = new Modal(document.getElementById('modalFinish'))
})

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/${route.path.split('/')[1]}/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('groupManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('listGroup'),
    to: `/${route.path.split('/')[1]}/communities/${route.params?.id}/admin/groups?created_at=asc`,
    active: false,
  },
  {
    content: translate('communityEditGroup'),
    to: `/${route.path.split('/')[1]}/communities/${route.params?.id}/admin/groups/${detailGroup.value.id}/edit`,
    active: false,
  },
  {
    content: translate('sendInviteOnlyInfo'),
    to: '',
    active: true,
  },
]

const formData = ref({
  community_message_template_id: '',
  title: '',
  content: '',
  destination: 0,
  sendReservation: 0,
  booking_date: new Date(),
  hours: '00',
  minutes: '00',
})

const rules = computed(() => {
  return {
    title: {
      required,
      maxLength: (value: string) => customMaxLength(value, 70),
      minLength: minLength(1),
      pictograms: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    content: {
      required,
      maxLength: (value: string) => customMaxLength(value, 2000),
      minLength: minLength(1),
      pictograms: function (value) {
        return REGEX_EMOJI.test(value)
      },
      urlNotFound: (value: string) => value.includes('#グループ招待URL#'),
    },
    booking_date: {
      requiredDate: function (value) {
        if (value) return true
      },
      pastDate: function (value) {
        const date = dayjs(new Date()).format('YYYY-MM-DD')
        if (!dayjs(value).isBefore(dayjs(date))) return true
      },
    },
  }
})
const v$ = useVuelidate(rules, formData)

watch(
  () => formData.value.sendReservation,
  () => {
    if (formData.value.sendReservation !== '1') {
      // set default booking_date value
      formData.value.booking_date = new Date()
      formData.value.hours = '00'
      formData.value.minutes = '00'
      validateTime.value = false
    }
  }
)

const FillData = () => {
  if (formData.value.community_message_template_id) {
    formData.value.title = dataMessageTemplate.value?.data.find((e) => e.id === formData.value.community_message_template_id)?.title
    formData.value.content = dataMessageTemplate.value?.data.find((e) => e.id === formData.value.community_message_template_id)?.content
  }
}

const BackPreviousPage = () => {
  router.go(-1)
}

const typeInTextarea = (newText, el = document.getElementById('content')) => {
  const start = el.selectionStart
  const end = el.selectionEnd
  const text = el.value
  const before = text.substring(0, start)
  const after = text.substring(end, text.length)
  el.value = before + newText + after
  formData.value.content = before + newText + after
  el.selectionStart = el.selectionEnd = start + newText.length

  // trigger event input to validate and show errors after change input value
  el.dispatchEvent(new Event('input'))
  el.focus()
}

const renderName = (management_no: string) => {
  const data = listRecordSelected.value?.find((e) => e.user_no === management_no)
  return data.family_name + ' ' + data.given_name + ' ' + data.display_name
}

const formatContent = (content: string) => {
  if (!content) return ''
  let escaped = purifyContent(content)

  const surNameTag = `#${translate('surName')}#`
  const nameTag = `#${translate('name')}#`
  const urlTag = `#${translate('invitationGroupUrl')}#`

  escaped = escaped.replace(new RegExp(surNameTag, 'g'), `<span class="active fw-bold">${surNameTag}</span>`)
  escaped = escaped.replace(new RegExp(nameTag, 'g'), `<span class="active fw-bold">${nameTag}</span>`)
  escaped = escaped.replace(new RegExp(urlTag, 'g'), `<span class="active fw-bold">${urlTag}</span>`)

  return escaped
}

const hanldeResponseMessage = ref('')
const SubmitTemplate = async (): Promise<void> => {
  loadingSend.value = true
  const data = {
    ...pick(formData.value, 'community_message_template_id', 'title', 'content'),
    send_mail: Number(formData.value.destination) === 1 ? true : false,
    booking_date:
      Number(formData.value.sendReservation) === 1
        ? ConvertFromUTCTime(dayjs(formData.value.booking_date).format('YYYY/MM/DD') + ' ' + formData.value.hours + ':' + formData.value.minutes)
        : '',
    management_no: listRecordSelected?.value?.map((e) => e.user_no),
    community_id: route.params.id,
    group_id: detailGroup.value.id,
  }
  try {
    const response = await messageTemplateServices.postInviteOnlyGroupMessages(data)
    dataReturn.value = response?.data?.data
    if (response.status === 200) {
      hanldeResponseMessage.value = 'registered'
      modalFinish.value.show()
      modal.value.hide()
    } else {
      if (response?.response?.data?.data[0]?.message_code === 'ERROR_INVITATION_GROUP_URL_NOT_FOUND') hanldeResponseMessage.value = 'ERROR_INVITATION_GROUP_URL_NOT_FOUND'
      else if (response?.response?.data?.data[0]?.message_code === 'VALIDATE_ALREADY_UPDATED_USER') hanldeResponseMessage.value = 'VALIDATE_ALREADY_UPDATED_USER'
      else hanldeResponseMessage.value = 'registeredFail'
      modalFinish.value.show()
      modal.value.hide()
    }
    // loadingSend.value = false
  } catch (error) {
    console.log(error)
    hanldeResponseMessage.value = 'registeredFail'
    loadingSend.value = false
    modalFinish.value.show()
    modal.value.hide()
  }
}

const transitToSelect = () => {
  router.push(`/community/communities/${route.params?.id}/admin/groups/${detailGroup.value?.id}/edit`)
}

const CheckTime = () => {
  if (formData.value.sendReservation === '1') {
    const date = dayjs(new Date())

    const minute = date.diff(dayjs(dayjs(formData.value.booking_date).format('YYYY/MM/DD') + ' ' + formData.value.hours + ':' + formData.value.minutes), 'minute')
    if (minute > -10) {
      validateTime.value = true
    } else {
      validateTime.value = false
    }
  }
}
const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  CheckTime()
  isCheckedNGKeyTitle.value = false
  isCheckedNGContent.value = false
  await checkNGTitle()
  await checkNGContent()
  while (!isCheckedNGKeyTitle.value || !isCheckedNGContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyTitle.value || ngKeyContent.value || validateTime.value) {
    nextTick(() => {
      const elementErrors = document.querySelector('.invalid-feedback')
      const classErrors = elementErrors ? '.invalid-feedback' : '.invalid-error'
      scrollToErrors(classErrors)
    })
    return
  }

  modal.value?.show()
}

const isCheckedNGKeyTitle = { value: false }
const ngKeyTitle = ref<boolean>(false)
const checkNGTitle = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.title.$model })
  ngKeyTitle.value = data.data?.data?.has_ngword
  isCheckedNGKeyTitle.value = true
}, 200)

const isCheckedNGContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGContent.value = true
}, 200)
const bookingDateInvalid = computed(() => validateTime.value || v$.value.booking_date.$error)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("form", {
      onSubmit: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["prevent"])),
      class: "bg-white rounded-4 shadow p-4 mb-4"
    }, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(translate)('sendInviteOnlyInfo')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(numberWithCommas)(_unref(listRecordSelected)?.length)) + "件のユーザを選択中", 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listRecordSelected), (user) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: user,
                  class: "d-flex px-3 py-2 display_management"
                }, [
                  _createVNode(UserAliasIcon, {
                    userType: user?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(user.user_no), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(user.family_name) + " " + _toDisplayString(user.given_name), 1),
                    (user.user_type === 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(" + _toDisplayString(user.display_name) + ")", 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h2", _hoisted_12, _toDisplayString(_unref(translate)('OE50messageContent')), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(translate)('OE12inviteGroupName')), 1),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("input", {
                  type: "content",
                  name: "groupName",
                  class: "form-control",
                  disabled: "",
                  value: _unref(detailGroup).name
                }, null, 8, _hoisted_18)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(translate)('OE50sample')), 1),
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "aria-label": "Default select example",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.community_message_template_id) = $event))
                }, [
                  _createElementVNode("option", _hoisted_24, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataMessageTemplate.value?.data, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      value: item?.id
                    }, _toDisplayString(item?.name), 9, _hoisted_25))
                  }), 128))
                ], 512), [
                  [_vModelSelect, formData.value.community_message_template_id]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", {
                class: _normalizeClass([
                'button-select shadow fw-bold cursor-pointer d-flex justify-content-center align-items-center',
                formData.value.community_message_template_id === '' ? 'disable-button' : '',
              ]),
                onClick: FillData
              }, _toDisplayString(_unref(translate)('OE50application')), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(translate)('title')), 1),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(Status)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("input", {
                  type: "content",
                  name: "title",
                  class: _normalizeClass(['form-control', ngKeyTitle.value || _unref(v$).title.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).title.$model) = $event)),
                  placeholder: _unref(translate)('placeholder'),
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(checkNGTitle) && _unref(checkNGTitle)(...args)))
                }, null, 42, _hoisted_32), [
                  [
                    _vModelText,
                    _unref(v$).title.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyTitle.value && !_unref(v$).title.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('title'),
                  params: [1, 70],
                  validator: _unref(v$).title.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(translate)('content')), 1),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(Status)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("textarea", {
                  id: "content",
                  name: "content",
                  class: _normalizeClass(['form-control', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                  rows: "10",
                  placeholder: _unref(translate)('placeholder'),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args)))
                }, null, 42, _hoisted_39), [
                  [_vModelText, _unref(v$).content.$model]
                ]),
                (ngKeyContent.value && !_unref(v$).content.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('content'),
                  params: [1, 2000],
                  validator: _unref(v$).content.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ]),
              _createElementVNode("p", _hoisted_41, _toDisplayString(_unref(translate)('CE10textarea2')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(translate)('CE10textarea3')), 1),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", {
                  class: "tag fs-8 d-flex align-items-center justify-content-center cursor-pointer bg-white",
                  onMousedown: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (typeInTextarea(`#${_unref(translate)('surName')}#`)), ["prevent"]))
                }, " #" + _toDisplayString(_unref(translate)('surName')) + "# ", 33),
                _createElementVNode("div", {
                  class: "tag ms-2 fs-8 d-flex align-items-center justify-content-center cursor-pointer",
                  onMousedown: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (typeInTextarea(`#${_unref(translate)('name')}#`)), ["prevent"]))
                }, " #" + _toDisplayString(_unref(translate)('name')) + "# ", 33),
                _createElementVNode("div", {
                  class: "tag-big ms-2 fs-8 d-flex align-items-center justify-content-center cursor-pointer",
                  onMousedown: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (typeInTextarea(`#${_unref(translate)('invitationGroupUrl')}#`)), ["prevent"]))
                }, " #" + _toDisplayString(_unref(translate)('invitationGroupUrl')) + "# ", 33)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(translate)('OE65sendMail')), 1),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: _ctx.flexRadioDefault1
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault1",
                    id: _ctx.flexRadioDefault1,
                    value: "0",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.destination) = $event))
                  }, null, 8, _hoisted_48), [
                    [_vModelRadio, formData.value.destination]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('OE50personal')), 1)
                ], 8, _hoisted_47)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: _ctx.flexRadioDefault2
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault2",
                    id: _ctx.flexRadioDefault2,
                    value: "1",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.destination) = $event))
                  }, null, 8, _hoisted_51), [
                    [_vModelRadio, formData.value.destination]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('OE50personalEmail')), 1)
                ], 8, _hoisted_50)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("label", _hoisted_53, _toDisplayString(_unref(translate)('OE50sendReservation')), 1),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: _ctx.immediate
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault",
                    id: _ctx.immediate,
                    value: "0",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.sendReservation) = $event))
                  }, null, 8, _hoisted_57), [
                    [_vModelRadio, formData.value.sendReservation]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('OE50immediate')), 1)
                ], 8, _hoisted_56)
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: _ctx.flexRadioDefault3
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault3",
                    id: _ctx.flexRadioDefault3,
                    value: "1",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.sendReservation) = $event))
                  }, null, 8, _hoisted_60), [
                    [_vModelRadio, formData.value.sendReservation]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('OE50specify')), 1)
                ], 8, _hoisted_59)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(['input-group mt-4', Number(formData.value.sendReservation) === 0 ? 'display' : ''])
              }, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      (Number(formData.value.sendReservation) === 0)
                        ? (_openBlock(), _createBlock(_unref(flatPickr), {
                            key: 0,
                            config: _unref(configMinDate),
                            class: "form-control",
                            disabled: ""
                          }, null, 8, ["config"]))
                        : _createCommentVNode("", true),
                      (Number(formData.value.sendReservation) === 1)
                        ? (_openBlock(), _createBlock(_unref(flatPickr), {
                            key: 1,
                            modelValue: _unref(v$).booking_date.$model,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).booking_date.$model) = $event)),
                            config: _unref(configMinDate),
                            class: _normalizeClass(['form-control bg-white', _unref(bookingDateInvalid) ? 'is-invalid' : '']),
                            onChange: CheckTime
                          }, null, 8, ["modelValue", "config", "class"]))
                        : _createCommentVNode("", true),
                      _hoisted_64
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)(`OE50specify`),
                      params: [10],
                      validator: _unref(v$).booking_date.$errors[0]?.$validator
                    }, null, 8, ["title", "validator"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    (Number(formData.value.sendReservation) === 0)
                      ? (_openBlock(), _createElementBlock("select", _hoisted_67, _hoisted_69))
                      : _createCommentVNode("", true),
                    (Number(formData.value.sendReservation) === 1)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 1,
                          class: "form-select fs-7",
                          "aria-label": "Default select example hours",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.hours) = $event)),
                          onChange: CheckTime
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HOURS), (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item,
                              value: item
                            }, _toDisplayString(item), 9, _hoisted_70))
                          }), 128))
                        ], 544)), [
                          [_vModelSelect, formData.value.hours]
                        ])
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_71, _toDisplayString(_unref(translate)('hours')), 1),
                    (Number(formData.value.sendReservation) === 0)
                      ? (_openBlock(), _createElementBlock("select", _hoisted_72, _hoisted_74))
                      : _createCommentVNode("", true),
                    (Number(formData.value.sendReservation) === 1)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 3,
                          class: "form-select fs-7",
                          "aria-label": "Default select example",
                          onChange: CheckTime,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.minutes) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MINUTES), (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item,
                              value: item
                            }, _toDisplayString(item), 9, _hoisted_75))
                          }), 128))
                        ], 544)), [
                          [_vModelSelect, formData.value.minutes]
                        ])
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_76, _toDisplayString(_unref(translate)('minutes')), 1)
                  ])
                ])
              ], 2),
              _createElementVNode("p", _hoisted_77, _toDisplayString(validateTime.value && !_unref(v$).booking_date.$error ? _unref(translate)('VALIDATE_CURRENT_DATE_TIME', '', [10]) : ''), 1),
              _createElementVNode("p", _hoisted_78, _toDisplayString(_unref(translate)('OE50text2')), 1),
              _createElementVNode("p", _hoisted_79, _toDisplayString(_unref(translate)('OE50text3')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _createVNode(Button, {
            title: _unref(translate)('back'),
            type: "secondary",
            className: "fw-bold",
            onClick: BackPreviousPage
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_82, [
          _createVNode(Button, {
            title: _unref(translate)('confirm'),
            type: "secondary",
            className: "fw-bold",
            onClick: onSubmit
          }, null, 8, ["title"])
        ])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_83, [
      _createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("h5", _hoisted_87, _toDisplayString(_unref(translate)('sendInviteOnlyInfo')), 1),
            _hoisted_88
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("h2", _hoisted_91, _toDisplayString(_unref(numberWithCommas)(_unref(listRecordSelected)?.length)) + "件のユーザを選択中", 1),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listRecordSelected), (user) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: user,
                        class: "d-flex p-2 display_management"
                      }, [
                        _createVNode(UserAliasIcon, {
                          userType: user?.user_type
                        }, null, 8, ["userType"]),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("span", _hoisted_95, _toDisplayString(user.user_no), 1),
                          _createElementVNode("span", _hoisted_96, _toDisplayString(user.family_name) + " " + _toDisplayString(user.given_name), 1),
                          (user.user_type === 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_97, "(" + _toDisplayString(user.display_name) + ")", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("h2", _hoisted_99, _toDisplayString(_unref(translate)('OE50messageContent')), 1),
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("label", _hoisted_101, _toDisplayString(_unref(translate)('OE12inviteGroupName')), 1),
                  _createElementVNode("div", _hoisted_102, _toDisplayString(_unref(detailGroup).name), 1)
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("label", _hoisted_104, _toDisplayString(_unref(translate)('OE50sample')), 1),
                  _createElementVNode("div", _hoisted_105, _toDisplayString(dataMessageTemplate.value?.data?.find((item) => item.id === formData.value.community_message_template_id)?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("label", _hoisted_107, _toDisplayString(_unref(translate)('title')), 1),
                  _createElementVNode("div", _hoisted_108, _toDisplayString(formData.value.title), 1)
                ]),
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("label", _hoisted_110, _toDisplayString(_unref(translate)('content')), 1),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("div", {
                      class: "w-100",
                      innerHTML: formatContent(formData.value.content)
                    }, null, 8, _hoisted_112)
                  ])
                ]),
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("label", _hoisted_114, _toDisplayString(_unref(translate)('OE65sendMail')), 1),
                  _createElementVNode("div", _hoisted_115, _toDisplayString(Number(formData.value.destination) === 0 ? _unref(translate)('OE50personal') : _unref(translate)('OE50personalEmail')), 1)
                ]),
                _createElementVNode("div", _hoisted_116, [
                  _createElementVNode("label", _hoisted_117, _toDisplayString(_unref(translate)('OE50titleDate')), 1),
                  _createElementVNode("div", _hoisted_118, _toDisplayString(Number(formData.value.sendReservation) === 0 ? _unref(translate)('OE50immediate') : '') + " " + _toDisplayString(Number(formData.value.sendReservation) === 1 ? _unref(dayjs)(formData.value.booking_date).format('YYYY/MM/DD') + ' ' + formData.value.hours + ':' + formData.value.minutes : ''), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_119, _toDisplayString(_unref(translate)('OE50textConfirm')), 1),
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("div", _hoisted_122, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: "secondary",
                    "data-bs-dismiss": "modal",
                    className: "fw-bold"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_123, [
                  _createVNode(Button, {
                    title: _unref(translate)('signUp'),
                    type: "secondary",
                    className: "fw-bold",
                    onClick: SubmitTemplate,
                    disabled: loadingSend.value,
                    loading: loadingSend.value
                  }, null, 8, ["title", "disabled", "loading"])
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_124, [
      _createElementVNode("div", _hoisted_125, [
        _createElementVNode("div", _hoisted_126, [
          _createElementVNode("div", _hoisted_127, [
            _createElementVNode("h5", _hoisted_128, _toDisplayString(_unref(translate)('sendInviteOnlyInfo')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: transitToSelect
            })
          ]),
          (dataReturn.value?.data_failed?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                _createElementVNode("div", _hoisted_130, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataReturn.value?.data_failed, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "mb-2 d-flex align-items-center",
                      key: index
                    }, [
                      _createVNode(UserAliasIcon, {
                        userType: item?.management_no?.charAt(0) === 'A' ? 2 : 1
                      }, null, 8, ["userType"]),
                      _createElementVNode("span", _hoisted_131, _toDisplayString(item?.management_no), 1),
                      _hoisted_132,
                      _createElementVNode("span", null, _toDisplayString(renderName(item?.management_no)), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_133, _toDisplayString(_unref(translate)(hanldeResponseMessage.value)), 1),
          _createElementVNode("div", _hoisted_134, [
            _createVNode(Button, {
              title: _unref(translate)('backToList'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              onClick: transitToSelect
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})